var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"assinar__botao-link",attrs:{"id":"botaoAssinar","href":_vm.urlDocumentoVirtualizado,"target":"_blank"}},[_c('i',{staticClass:"fas fa-signature",attrs:{"aria-hidden":"true"}}),_vm._v(" Assinar ")])}
var staticRenderFns = []

export { render, staticRenderFns }